import { cva, cx } from '@vizit/theme';

interface CardContentProps extends React.HTMLAttributes<HTMLDivElement> {}

const classes = {
  root: cva({
    base: 'p-8',
  }),
};

function CardContent(props: CardContentProps) {
  const { children, className, ...rest } = props;

  return (
    <div className={cx(classes.root, className)} {...rest}>
      {children}
    </div>
  );
}

export { CardContent };
